export default __webpack_public_path__ + "static/avatar-dont-2-dark-3d7745bc3402f73f3a209ed95d1863ad.png";